<template>
	<div>
		<el-dialog
			title="操作验证"
			:visible="validImgShow"
			width="600px"
			height="300px"
			@close="cancelValidImgFunc"
		>
			<el-form
				ref="imgValidForm"
				:model="imgValidForm"
				:rules="imgRules"
				label-width="80px"
			>
				<el-form-item label="验证码" prop="validImgInput">
					<el-input
						v-model="imgValidForm.validImgInput"
						style="width: 160px; float: left; margin-right: 10px"
					></el-input>
					<img
						:src="validImgSrc"
						alt="验证码图片"
						style="margin-right: 10px; float: left; max-height: 40px"
					/>
					<el-button type="text" @click="setValidImageFunc"
						>看不清？换一张</el-button
					>
				</el-form-item>
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="cancelValidImgFunc">取 消</el-button>
				<el-button type="primary" @click="submitValidImgFunc">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { setValidImage } from '@/services/login'

export default {
	name: 'ValidImgLayer',
	props: {
		validImgShow: {
			type: Boolean,
			default: false,
			required: true
		},
		phoneNumber: {
			type: [String, Number]
			// required:true
		},
		loginNoPhone: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			showDialog: false,
			validImgSrc: '',
			imgValidForm: {
				validImgInput: ''
			},
			imgRules: {
				validImgInput: [
					{ required: true, message: '图形验证码不能为空', trigger: 'blur' }
				]
			}
		}
	},
	watch: {
		validImgShow: function(newVal, oldVal) {
			console.log('-----validImgShow-----')
			console.log(newVal)
			console.log(oldVal)
			// 刷新图片验证码
			if (newVal) {
				console.log(this)
				// 使用nextTick确保DOM已更新
				this.$nextTick(() => {
					// 给一个短暂的延迟确保组件已完全挂载
					setTimeout(() => {
						this.setValidImageFunc()
					}, 100)
				})
			}
		}
	},
	methods: {
		setValidImageFunc() {
			console.log(this)
			let phoneNumber = this.phoneNumber
			this.imgValidForm.validImgInput = ''
			console.log(this.imgValidForm)
			this.imgValidForm.validImgInput = ''
			// this.validImgSrc = setValidImage({mobile: phoneNumber})
			if (this.loginNoPhone) {
				this.validImgSrc =
					'/whale-pc/verify-code/captcha.jpg?token=' + new Date().getTime()
			} else {
				this.validImgSrc =
					process.env.BASE_URL +
					'/whale-pc/verify-code/image?mobile=' +
					phoneNumber +
					'&t=' +
					new Date().getTime()
			}

			// setValidImage({mobile: phoneNumber}).then(res => {
			//   console.log(res)
			// 	// 展示图片弹窗
			// 	// this.validImgShow = true

			// })
		},
		cancelValidImgFunc() {
			this.$emit('closeValidImg')
		},
		submitValidImgFunc() {
			let params = {}
			params.validImgInput = this.imgValidForm.validImgInput
			this.$refs['imgValidForm'].validate(valid => {
				if (valid) {
					this.$emit('updateValidImg', params)
				} else {
				}
			})
		}
	},
	created() {
		console.log('---created--')
		// this.setValidImageFunc()
		// this.showDialog = this.validImgShow
		// alert(22)
	},
	updated() {
		console.log('---updated--')
		// if(this.validImgShow){
		//   this.setValidImageFunc()
		// }
	}
}
</script>
